import React, { useEffect, useRef } from 'react';
import styled, { css } from '@xstyled/styled-components';
import { CarouselVariants } from '../CarouselStore';

const StyledCarouselItem = styled.div<{
  variant: CarouselVariants;
  index: number;
  current: number;
  total: number;
  disabled?: boolean;
  editorModeParam?: boolean;
  cssStylesForItem?: string | Record<string, string>;
}>`
  grid-area: item;
  align-self: center;
  justify-self: center;
  z-index: ${p => p.total + 1 - p.index};

  ${p => {
    if (p.disabled) {
      return css`
        z-index: 1;
      `;
    }
  }}

  ${p => {
    if (p.disabled) {
      return css`
        button {
          display: none !important;
        }
      `;
    }
  }}

  ${p => {
    switch (p.variant) {
      case 'horizontal':
        return css`
          transform: translateX(${(p.index - p.current) * 150}%);
          opacity: ${p.index === p.current ? 1 : 0};
          transition: all ease-in-out 0.7s;

          ${p.editorModeParam &&
          css`
            height: 80vh;
            overflow-y: auto;
            padding-right: 6px;

            &::-webkit-scrollbar {
              width: 4px;
            }

            &::-webkit-scrollbar-track {
              background: transparent;
              margin: 10px 0;
            }

            &::-webkit-scrollbar-thumb {
              background-color: rgba(128, 128, 128, 0.5);
              border-radius: 2px;
            }

            &::-webkit-scrollbar-thumb:hover {
              background-color: rgba(128, 128, 128, 0.8);
            }
          `}
        `;
      case 'vertical':
        return css`
          transform: translateY(${(p.index - p.current) * 150}%);
          opacity: ${p.index === p.current ? 1 : 0};
          transition: all ease-in-out 0.7s;
        `;
      case 'stack':
        return css`
          opacity: ${p.index >= p.current ? 1 : 0};
          transform: translateY(${p.index < p.current ? '-120%' : '0'})
            rotate(${(p.index - p.current) * 3}deg);
          transition: all ease-in-out 0.3s;
        `;
    }
  }}

  ${p => {
    if (p.cssStylesForItem) {
      return css`
        ${p.cssStylesForItem}
      `;
    }
  }}
`;

interface CarouselItemProps extends React.ComponentProps<
  typeof StyledCarouselItem
> {
  inert?: boolean;
}

//we need it because of the inert attribute
export const CarouselItem = ({ inert, ...props }: CarouselItemProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (inert) {
      el.setAttribute('inert', '');
    } else {
      el.removeAttribute('inert');
    }
    return () => el.removeAttribute('inert');
  }, [inert]);
  return <StyledCarouselItem ref={ref} {...props} />;
};
